import Container from './container'
export default Container



// WEBPACK FOOTER //
// ./src/components/container/index.js